import { BrowserRouter } from "react-router-dom";

import "./App.scss";
import Routers from "./Routes/index";

function App() {
  return (
    <BrowserRouter>
      <Routers />
    </BrowserRouter>
  );
}

export default App;
